import { differenceInYears } from 'date-fns';

export const formatAge = (birthday: string, deathday: string | null | undefined) => {
  const birthDate = new Date(birthday);

  if (deathday) {
    const deathDate = new Date(deathday);
    return `${String(birthDate.getFullYear())}-${String(deathDate.getFullYear())} (${String(differenceInYears(deathDate, birthDate))})`;
  }

  return `${String(differenceInYears(new Date(), birthDate))} years old`;
};
